<template>
  <div>
    <v-row
      justify="center"
      style="box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 1),
    0 24px 38px 3px rgba(0, 0, 0, 1), 0 9px 46px 8px rgba(0, 0, 0, 1) !important;"
    >
      <v-dialog
        :hide-overlay="false"
        v-model="open"
        persistent
        max-width="400px"
        style="box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 1),
    0 24px 38px 3px rgba(0, 0, 0, 1), 0 9px 46px 8px rgba(0, 0, 0, 1) !important;"
      >
        <v-card>
          <v-card-title class="centraliza">
            <span class="headline">Informe um e-mail</span>
          </v-card-title>
          <v-container>
            <div class="centraliza" style="flex-wrap: wrap">
              <v-text-field
                counter="60"
                name="input-6-1"
                label="E-mail do usuário"
                v-model="email"
              ></v-text-field>
            </div>
          </v-container>
          <v-card-actions class="centraliza">
            <v-btn color="#2A5377" style="color: #fff" text @click="$emit('cancel')">Cancelar</v-btn>
            <v-btn
              :loading="loading4"
              :disabled="loading4"
              color="#2A5377"
              style="color: #fff"
              text
              @click="validate()"
            >
              Confirmar
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import * as ClientesService from "../../providers/clientes.service";
import * as AtlassianService from "../../providers/atlassian.service";

import store from '@/store/index.js'

const md5 = require("MD5");
export default {
  props: ["open", "cliente"],
    data: () => ({
    loading4: false,
    url: process.env.VUE_APP_API_URL + "/emsweb/userlogin"
  }),
  created() {
    var self = this;
    ClientesService.getEmailJira({
      CLICODIGO: self.cliente.CLICODIGO
    }).then(r => {
      this.email = r.CLIJIEMAIL;
    });
  },  
  methods: {
    validate() {
      var self = this;
      self.loading4 = true;

      ClientesService.changeAplicativoChamados({
        CLICODIGO: self.cliente.CLICODIGO,
        CLIAPPSUPORTE: "2",
        CLINOME: self.cliente.CLINOME
      })
        .then(r => {
          ClientesService.setEmailJira({
              ORGANIZATIONID: r.organizationId,
              EMAIL: self.email,
              CLINOMEUSUAL: self.cliente.CLINOMEUSUAL + " - " + self.cliente.MUNMUNICIPIO
            })
              .then(r => {
                self.$emit("success");
                self.loading4 = false;
              })
              .catch(err => {
                self.$emit("cancel");
                self.loading4 = false;
              }); 
        })
        .catch(err => {
          self.$emit("cancel");
          self.loading4 = false;
        });                
    }
  }
};
</script>
<style >
.v-dialog {
  -webkit-box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
  border-radius: 8px !important;
  margin: 24px !important;
  overflow-y: auto;
  pointer-events: auto;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit !important;
}
.centraliza {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>